import { CONTEXT_PATH } from '@confluence/named-routes/entry-points/context.ts';

import type { Template } from './createContentFromTemplateTypes.ts';

export const processDraftUrl = (url: string | undefined | null): string => {
	if (!url) {
		throw new Error('No editor url for new content');
	}
	if (url.startsWith(CONTEXT_PATH)) {
		return url;
	}
	return `${CONTEXT_PATH}${url}`;
};

export const parseContentIdFromDraftUrl = (url: string | null | undefined): string | null => {
	if (!url) {
		return null;
	}

	const match = /\/edit-v2\/([^/?#]+)/.exec(url);
	return match?.[1] ?? null;
};

export const notifyContentCreatedFromDraftUrl = (
	draftUrl: string | null | undefined,
	template: Template,
	onContentCreated?: (contentId: string, template: Template) => void,
): void => {
	if (!onContentCreated) {
		return;
	}

	const contentId = parseContentIdFromDraftUrl(draftUrl);
	if (contentId) {
		onContentCreated(contentId, template);
	}
};
